import { render, staticRenderFns } from "./StagingCreatePanel.vue?vue&type=template&id=45aa050a&scoped=true&"
import script from "./StagingCreatePanel.vue?vue&type=script&lang=ts&"
export * from "./StagingCreatePanel.vue?vue&type=script&lang=ts&"
import style0 from "./StagingCreatePanel.vue?vue&type=style&index=0&id=45aa050a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aa050a",
  null
  
)

export default component.exports